/* eslint-disable react/display-name */
import { relation } from 'components/Generic/genericHelper';
import Loader from 'components/Loader';

const routes = [
	{
		path: '/list/ritualCredentials',
		sideMenu: true,
		layout: 'list',
		container: Loader(() => import('components/Generic/GenericList')),
		containerProps: {
			query: `
             query Q($limit: Int!, $offset: Int!) {
                 ritualCredentials(limit: $limit, offset: $offset) {
                    id,
                    displayName
                    merchant: merchantCuboh {
                        id
                        name
                    }
                    company {
                        id
                        name
                    }
                    active
                 }
              }
         `,
			...relation('ritualCredential', 'many'),
			relations: [
				relation('merchant', 'single'),
				relation('company', 'single'),
			],
			excludeColumns: ['displayName'],
		},
		showSearch: false,
	},
	{
		path: '/list/ritualCredentials/:id',
		sideMenu: false,
		layout: 'list',
		container: Loader(() => import('components/Generic/GenericDetail')),
		containerProps: {
			query: `
             query Q($id: Int!) {
                 ritualCredential(id: $id) {
                    id,
                    displayName
                    active
                    merchant: merchantCuboh {
                        id
                        name
                    }
                    company {
                        id
                        name
                    }
                 }
              }
         `,
			...relation('ritualCredential', 'single'),
			relations: [
				relation('merchant', 'single'),
				relation('company', 'single'),
			],
		},
	},
];

export default routes;
